import produce from "immer";
import { commonActions } from ".";
import { IStoreState } from "..";
import { defaultCommonState } from "./common.types";
import {
  CLEAR_AUDIT_LOGS,
  CLEAR_GENERAL_HISTORY_STATE,
  CLEAR_RECORD_COUNTS,
  FETCH_ACTIVITY_COMMENT_FAILED,
  FETCH_ACTIVITY_COMMENT_PROGRESS,
  FETCH_ACTIVITY_COMMENT_SUCCESS,
  FETCH_AUDIT_LOGS_FAILED,
  FETCH_AUDIT_LOGS_PROGRESS,
  FETCH_AUDIT_LOGS_SUCCESS,
  FETCH_GENERAL_HISTORY_LIST_FAILED,
  FETCH_GENERAL_HISTORY_LIST_PROGRESS,
  FETCH_GENERAL_HISTORY_LIST_SUCCESS,
  FETCH_POLCIES_FAILED,
  FETCH_POLICIES_PROGRESS,
  FETCH_POLICIES_SUCCESS,
  FETCH_RECORD_COUNTS_FAILED,
  FETCH_RECORD_COUNTS_PROGRESS,
  FETCH_RECORD_COUNTS_SUCCESS,
} from "./commonActions";
import { LoadState } from "../../constants/enums";

export const commonReducer = (
  state: IStoreState["common"] = defaultCommonState,
  action: commonActions,
) => {
  switch (action.type) {
    case FETCH_POLICIES_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.policies.loadState = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_POLICIES_SUCCESS: {
      const { policies } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.policies.loadState = LoadState.Loaded;
        draftState.policies.list = policies;
      });
      return newState;
    }
    case FETCH_POLCIES_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.policies.loadState = LoadState.Failed;
        draftState.policies.list = [];
      });
      return newState;
    }

    case FETCH_GENERAL_HISTORY_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.generalHistory.loading = LoadState.InProgress;
        draftState.generalHistory.list = [];
      });
      return newState;
    }
    case FETCH_GENERAL_HISTORY_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.generalHistory.loading = LoadState.Loaded;
        draftState.generalHistory.list = data;
      });
      return newState;
    }
    case FETCH_GENERAL_HISTORY_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.generalHistory.loading = LoadState.Failed;
        draftState.generalHistory.list = [];
      });
      return newState;
    }
    case CLEAR_GENERAL_HISTORY_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.generalHistory = defaultCommonState["generalHistory"];
      });
      return newState;
    }

    case FETCH_RECORD_COUNTS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.generalHistory.loading = LoadState.InProgress;
        draftState.generalHistory.list = [];
      });
      return newState;
    }
    case FETCH_RECORD_COUNTS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.recordCounts.loading = LoadState.Loaded;
        draftState.recordCounts.list = data;
      });
      return newState;
    }
    case FETCH_RECORD_COUNTS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.recordCounts.loading = LoadState.Failed;
        draftState.recordCounts.list = [];
      });
      return newState;
    }
    case CLEAR_RECORD_COUNTS: {
      const newState = produce(state, (draftState) => {
        draftState.recordCounts = defaultCommonState["recordCounts"];
      });
      return newState;
    }
    case FETCH_ACTIVITY_COMMENT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.activityComment.loading = LoadState.InProgress;
        draftState.activityComment.list = [];
      });
      return newState;
    }
    case FETCH_ACTIVITY_COMMENT_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.activityComment.loading = LoadState.Loaded;
        draftState.activityComment.list = data;
      });
      return newState;
    }
    case FETCH_ACTIVITY_COMMENT_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.activityComment.loading = LoadState.Failed;
        draftState.activityComment.list = [];
      });
      return newState;
    }

    case FETCH_AUDIT_LOGS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.auditLogs.loading = LoadState.InProgress;
        draftState.auditLogs.list = [];
      });
      return newState;
    }
    case FETCH_AUDIT_LOGS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.auditLogs.loading = LoadState.Loaded;
        draftState.auditLogs.list = data;
      });
      return newState;
    }
    case FETCH_AUDIT_LOGS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.auditLogs.loading = LoadState.Failed;
        draftState.auditLogs.list = [];
      });
      return newState;
    }
    case CLEAR_AUDIT_LOGS: {
      const newState = produce(state, (draftState) => {
        draftState.auditLogs = defaultCommonState["auditLogs"];
      });
      return newState;
    }
    default: {
      return state;
    }
  }
};
